module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pass-recovery"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": require('../../assets/logoPonce.png')
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v(_vm._s(_vm.$t('PassRecovery.forgottenPassword')))]), _vm._v(" "), (_vm.recoveryEmailSent) ? _c('div', [_c('div', {
    staticClass: "recovery-message",
    domProps: {
      "innerHTML": _vm._s(_vm.recoveryMessage())
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "div-reset-password",
    attrs: {
      "row": ""
    }
  }, [_c('a', {
    staticClass: "text-reset-password",
    on: {
      "click": _vm.signIn
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.$t('PassRecovery.signIn')))])])])], 1) : _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPassRecovery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.validInput),
      callback: function($$v) {
        _vm.validInput = $$v
      },
      expression: "validInput"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-email",
    attrs: {
      "prepend-inner-icon": "mail",
      "name": "email",
      "label": _vm.$t('PassRecovery.email'),
      "id": "email",
      "type": "email",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "submit-layout",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "submit-btn",
    attrs: {
      "block": "",
      "color": "info",
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('PassRecovery.sendRecoveryLink')))])], 1)])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "div-reset-password",
    attrs: {
      "row": ""
    }
  }, [_c('a', {
    staticClass: "text-reset-password",
    on: {
      "click": _vm.signIn
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.$t('PassRecovery.signIn')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-214caa0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/PassRecovery.vue
// module id = 1691
// module chunks = 0